import axios from 'axios';

const apiClient = axios.create({
    baseURL: 'https://as.little-start-rs2025.workers.dev',
    timeout: 10000,
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('sessionId');
        console.log(token);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
    (response) => response.data,
    (error) => {
        console.log(error.response);

        if (error.response?.status === 401) {
            const skipAuthRedirect = error.config?._skipAuthInterceptor;
            if (skipAuthRedirect) {
                // 如果带了免死金牌，证明是第三方（如TikTok）的401，仅打印错误，绝不登出网站！
                console.warn('Third-party 401 detected, skipped global log-out redirect.');
            } else {
                console.error('Rnauthorized, redirecting...');
                localStorage.removeItem('sessionId');
                localStorage.removeItem('user');
                window.location.href = '/signin';
            }
        }
        return Promise.reject(error.response?.data || error.message);
    }
);

export default apiClient;